import { Badge } from '@/common/ui/badge'

interface Tag {
	id: string
	name: string
	color: string
	minDepositAmount?: number | null
}

interface PlayerTagsCellProps {
	tags: Tag[]
}

export function PlayerTagsCell({ tags }: PlayerTagsCellProps) {
	if (!tags || tags.length === 0) {
		return <span className="text-sm text-muted-foreground">-</span>
	}

	return (
		<div className="flex max-w-[180px] flex-wrap gap-1">
			{tags.map((tag) => (
				<Badge
					key={tag.id}
					variant="outline"
					className="text-xs"
					style={{
						borderColor: tag.color,
						color: tag.color,
						backgroundColor: `${tag.color}10`,
					}}
				>
					<span
						className="mr-1 h-2 w-2 rounded-full"
						style={{ backgroundColor: tag.color }}
					/>
					{tag.name}
				</Badge>
			))}
		</div>
	)
}
